export default __webpack_public_path__ + "static/form-sent-169c94ca721c86c8d9ca0e3515f5e7b7.svg";